import { Events } from 'global/constants';

const orderHistoryDateFilter = OdSelect => {
	const dateFilterSelect = document.querySelector(
		'[data-id="dateFilterSelect"]',
	);

	dateFilterSelect.addEventListener('change', submitForm);

	const odSelectInstance = new OdSelect(dateFilterSelect, {
		classNames: { bemModifiers: ['order-history-view'] },
	});
	odSelectInstance.addEventListener(Events.CHOICES_CHOICE, submitForm);
};

const submitForm = async () => {
	// We need to wait a bit because the odSelect element is not ready by this point due to choices.js
	await Promise.resolve();
	const dateFilterForm = document.querySelector(
		'[data-id="orderHistoryDateFilter"]',
	);
	if (dateFilterForm) {
		dateFilterForm.submit();
	}
};

export { orderHistoryDateFilter as default, submitForm };
